import React, { Component }          from 'react';

import icPencil                      from '../../img/ic_pencil.svg';
import icMore                        from '../../img/ic_more.svg';
import icAdd                         from '../../img/ic_add.svg';
import icDelete                      from '../../img/ic_delete.svg';
import icLeftArrow                   from '../../img/ic_left_arrow.svg';
import icRightArrow                  from '../../img/ic_right_arrow.svg';

import "./Admins.scss";

class Locations extends Component {

  constructor(props) {
    super(props);

    this.state            = {
    }
  }

  renderPagingNumbers() {
    const pageSize = 8;
    const firstItem = this.props.currentPage * pageSize + 1;
    const lastItem = firstItem + pageSize >= this.props.maxResults ? this.props.maxResults : firstItem + pageSize - 1; 
    return `${firstItem}-${lastItem} of ${this.props.maxResults}`;
  }

  downloadCSVFile(linkUrl) {
    fetch(linkUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
      },
    })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `users.csv`,
      );

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    });
  }

  renderLineItems() {
    let lineItems = [];
    let itemsToRender = this.props.locations ? this.props.locations : [];
    for (let i = 0; i < itemsToRender.length; i++) {
      lineItems.push(
        <div className="line-item" key={i}>
            <div className="fields">
              <div className="field">{itemsToRender[i].name}</div>
              <div className="field">{itemsToRender[i].accessKey}</div>
              <div className="field">{itemsToRender[i].contactEmail}</div>
              <div className="field">{itemsToRender[i].urlKey}</div>
            </div>
            <div className="icons">
              <img onClick={() => this.showMoreMenu(i)} src={icMore} />
              <div className={`more-menu ${this.state.moreMenuIndex === i ? 'show' : ''}`}>
                <div onClick={() => {
                  this.dismissMoreMenu()
                  this.props.showEditDialog(itemsToRender[i])
                }} className="item">Edit</div>
                <div onClick={() => {
                  this.dismissMoreMenu()
                  this.props.showDeleteDialog(itemsToRender[i])
                }} className="item">Delete</div>
                <div onClick={() => {
                  this.dismissMoreMenu()
                  this.downloadCSVFile(`/api/locations/${itemsToRender[i].id}/download_csv`)
                }} className="item">Download Users CSV</div>
              </div>
            </div>
        </div>
      );
    }
    return lineItems;
  }

  dismissMoreMenu() {
    this.setState({moreMenuIndex: -1})
  }

  showMoreMenu(i) {
    this.setState({moreMenuIndex: i})
  }

  render() {
    return (
      <div className={`admins__container ${this.props.currentState === "LOCATIONS" ? 'show' : ''}`}>
        <div className="line-item-header">
          <div className="column-names">
            <div className="name">Location Name</div>
            <div className="name">Access Key</div>
            <div className="name">Email</div>
            <div className="name">Url Key</div>
          </div>
          <div className="icons">
            <div className="paging">
              <img className={`${this.props.currentPage === 0 ? 'disable' : 'enable'}`} onClick={() => this.props.decrementPage("RECORDINGS")} src={icLeftArrow}/>
              <div className="page-numbers">{this.renderPagingNumbers()}</div>
              <img className={`${(this.props.currentPage + 1)*8 >= this.props.maxResults ? 'disable' : 'enable'}`} onClick={() => this.props.incrementPage("RECORDINGS")} src={icRightArrow}/>
            </div>
            <img onClick={() => this.props.showAddDialog()} src={icAdd}/>
          </div>
        </div>
        <div className="line-items-container">
          <div className="line-items">
            { this.renderLineItems() }
          </div>
        </div>
        <div onClick={this.dismissMoreMenu.bind(this)} className={`more-menu-click-target ${this.state.moreMenuIndex >= 0 ? 'show' : ''}`}></div>
      </div>
    );
  }
}

export default Locations;